module.exports = __webpack_public_path__ + "static/media/1_11.f978adab.jpg";